export const fixedDigits = (value: string | number, divider: number) => {
  const afterDotValue = String(+value / divider).replace(/(.+)\.(.+)$/, '$2');
  const afterDotLength = afterDotValue.replace(/[0]+$/, '').length;

  return (+value / divider).toFixed(afterDotLength);
};